<template>
<div class="chapter">
<div class="inner_page">
<div id="pgepubid00000">
<h1 id="calibre_pb_1">Charles Dickens<br class="calibre9"/>
<span class="small">And Other Victorians</span></h1>
<h2 class="sigil_not_in_toc">Arthur Quiller-Couch</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?20df49ca